<template>
  <div dir="rtl" class="behfam-logo-container">
    <!-- استفاده از خود SVG برای نمایش دقیق لوگو -->
    <svg 
      id="Layer_2" 
      data-name="Layer 2" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 390.3 507.5" 
      class="behfam-svg"
    >
      <!-- مسیر اصلی لوگو -->
      <path class="behfam-path" d="M225.8,43.9V317.7h312v-78H499.6v37.6H418.8V200.8H304.1V278l-38.6-.7V84.2H577.4V510.6H265.5V394.8h38.6v77.4H418.8V356.3h-193V551.4H616.1V43.9ZM342.3,239.7l39-.3v37.9s-39-.8-39,0Zm0,155.1h39v39.7h-39Z" transform="translate(-225.8 -43.9)"/>
      
      <!-- نقاط -->
      <circle class="behfam-dot-first" cx="254.4" cy="371.6" r="18.4"/>
      <circle class="behfam-dot-second" cx="136" cy="99.5" r="18.4"/>
    </svg>

    <p style="font-size: 1.7vw !important; font-weight: 900" class="behfam-loader-text">{{name}}</p>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.behfam-loader-text {
  position: absolute;
  width: 19vw;
  bottom: -17vw;
  right: -9vw;
  color: #fff; /* اطمینان از سفیدی متن */
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: center;
}

.behfam-logo-container {
  position: relative;
  /* تنظیم سایز کلی کانتینر */
  width: 20vw; 
  height: 26vw;
  display: flex;
  justify-content: center;
  align-items: center;
  /* اضافه کردن پس‌زمینه مشکی برای دیدن لوگوی سفید */
 
  border-radius: 1vw; /* کمی گرد کردن گوشه‌های کانتینر (اختیاری) */
  animation: behfam-fadeLogo 4s ease-in-out infinite alternate;
}

/* تنظیمات SVG برای پر کردن کانتینر */
.behfam-svg {
  width: 8vw;
  max-width: 8vw;
  /* انیمیشن ورود برای خود SVG */
  animation: behfam-stretchElement 2s ease-out;
}

/* تنظیم رنگ سفید برای اجزای لوگو */
.behfam-path, .behfam-dot-first, .behfam-dot-second {
  fill: #fff !important;
}

@keyframes behfam-fadeLogo {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

@keyframes behfam-stretchElement {
  0% { transform: scale(0); }
  100% { transform: scale(1); }
}

/* انیمیشن ضربان برای نقاط داخل SVG */
.behfam-dot-first, .behfam-dot-second {
  transform-box: fill-box;
  transform-origin: center;
  animation: behfam-pulseDot 2s ease-in-out infinite alternate;
}

@keyframes behfam-pulseDot {
  0% { transform: scale(1); }
  100% { transform: scale(1.2); }
}
</style>